import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { prospectFetch, setHeaderIds } from '@americanexpress/axp-acquisition-components-common';
import { useProductContext } from '../../Product';
import { useErrorContext } from '../../Common/ErrorPageProvider';
import Spinner from '../../Common/Spinner';

export default function Eligibility({ next }) {
  const { host, locale, setEligibilityData } = useProductContext();
  const { handleError } = useErrorContext();

  useEffect(() => {
    const fetchEligibility = async () => {
      try {
        const data = await prospectFetch(`${host}/application/v1/eligibility`, {
          method: 'POST',
          body: JSON.stringify({
            locale,
          }),
        });
        await setEligibilityData(data);
        if (data.eligibleCards.length > 99) {
          handleError(
            {
              logData: {
                message: 'Cards length > 99',
              },
              analyticTag: 'IneligibleError',
              message: 'technical',
            }
          );
        } else {
          next();
        }
        // eslint-disable-next-line no-empty
      } catch (error) {
        handleError({
          logData: { message: 'eligibility API failed' },
        });
      }
    };
    setHeaderIds({ transactionId: null });
    fetchEligibility();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="fluid">
      <Spinner />
    </div>
  );
}

Eligibility.propTypes = {
  next: PropTypes.func.isRequired,
};
